<script type="text/javascript">
	import moment from "moment";
	import { onMount, onDestroy } from "svelte";
	import { get, writable } from "svelte/store";

	import MapStore from "../../Map/Store";
	import MapLayerManager from "../../Map/MapLayerManager";
    import ModalWindow from "../../UI/ModalWindow.svelte"

	import LoadState from "../../Enums/LoadState";

	import SatRFStore from "./Store";
import Feature from "../../Branding/Feature";
import User from "../../Branding/User";

	// let features = SatRFStore.results.features;
	let mapInitialised = MapStore.meta.initialised;
    let visible = SatRFStore.meta.visible;
    let loadState = SatRFStore.meta.loadState;

	let initedDefaultView = false;

	$: {
		if ($mapInitialised && !initedDefaultView) {
			if (User.hasFeature(Feature.SATELLITE_RFD.VIEW)) {
				$visible = true;
			}
			initedDefaultView = true;
		}

		if ($visible) {
		    SatRFStore.actions.initMap( MapStore.helpers.getMap() );
		    SatRFStore.actions.init();
        }
		else {
			SatRFStore.actions.deinitMap();
		}
		MapLayerManager.updateVisibleLayers();
	};

</script>

<ModalWindow
	title={`Satellite-derived RF Detection`}
	hasCloseButton={true}
	hasBackground={false}
	resizable={true}
	draggable={true}
	fullscreen={false}
	padding={true}
	position="top-right"
	height="70%"
	bind:open={$visible}
	>
	{#if $loadState !== LoadState.LOADED}
		<p>Loading...</p>
	{:else}
		<p>When this window is open, the RF detections are visible.</p>
		<img src='/img/logos/KLEOSmodifiedPNG.png' style='width:36%;float:left;margin-right:5%;' alt='Kleos'/>
		<img src='/img/homepage/Geollect-logo_no-strap.svg' style='width:26%;margin-top:8px;float:left;' alt='Geollect'/>
	{/if}
</ModalWindow>

